import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../redux/items/types"
import BusinessDetails from "./BusinessDetails"
import { getBusinessLoans, resetBusinessLoans } from "../../redux/actions/loans"

class DetailBusiness extends Component {

  componentDidMount() {

    const { business, doResetBusinessLoans, setCurrentBusinessId, loadBusinesses, params } = this.props
    doResetBusinessLoans()
    setCurrentBusinessId(params.id)

    if(!business) {
      loadBusinesses()
    }
  }

  render() {
    const { business, businessLoans, getBusinessLoans } = this.props
    if(!business) return null

    return <BusinessDetails
      business={ business }
      businessLoans={ businessLoans }
      getBusinessLoans={ getBusinessLoans }
    />
  }
}

DetailBusiness.propTypes = {
  business: PropTypes.object,
  setCurrentBusinessId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {

  const business = DckSelectors.selectItemById(
    state,
    ItemTypes.Business,
    ownProps.params.id
  ),

  businessLoans = DckSelectors.selectAllItems(
    state,
    ItemTypes.BusinessLoans
  )

  return { business, businessLoans }
},

mapDispatchToProps = dispatch => ({

  setCurrentBusinessId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Business, id)),

  loadBusinesses: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Business)),

  getBusinessLoans: businessId => dispatch(getBusinessLoans(businessId)),

  doResetBusinessLoans: () => dispatch(resetBusinessLoans()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailBusiness)



// WEBPACK FOOTER //
// ./src/components/Business/Detail.js